import JobLayout from "./JobLayout.tsx";
import {JobsPostings} from "../jobs.ts";
import {imageMap} from "../../../images/imageMap.ts";
import IconOpenInNew from "../../../components/icons/IconOpenInNew.tsx";
import Icon from "../../../components/selfcare/Icon.tsx";

export default function JobCXManager20250626() {
    return <JobLayout job={JobsPostings.CXManager20250626}>
        <p>
            Vil du være kundens stemme i en digital hverdag, og har du erfaring med at gøre kunderejsen enklere, smartere og sjovere?
        </p>
        <p>
            Vi søger dig, der både kan tænke strategisk og arbejde praktisk med at forbedre kundeoplevelser, baseret på data og indsigter.
        </p>
        <p>
            <img src={imageMap.jobs.three_employess_speaking} alt={'Et billede af Hipers medarbejdere.'}/>
        </p>

        <h2 className={'heading heading--montserrat heading--left heading--medium'}>
            Hvad handler jobbet om?
        </h2>
        <p>
            Du bliver ansvarlig for at udvikle og optimere vores digitale kundeoplevelser;
            fra Mit Hiper og hjælpesider til e-mails, artikler og serviceflows.
            Du spotter, hvor tingene halter, og griber fat, hvor det gør en forskel.
            Samtidig samarbejder tæt med teams på tværs og bruger data til at træffe og kvalificere beslutninger.
        </p>

        <h2 className={'heading heading--montserrat heading--left heading--medium'}>
            Dine opgaver:
        </h2>
        <ul className={'list list--bullet'}>
            <li>Prioritere og drive CX-initiativer på tværs af Hiper.</li>
            <li>Identificere og løse pain points med afsæt i data og feedback.</li>
            <li>Optimere Mit Hiper og hjælpesider, så de er intuitive og effektive.</li>
            <li>Skabe klar, relevant og brugervenlig kundekommunikation.</li>
            <li>Omsætte NPS og kundeindsigter til konkrete forbedringer.</li>
            <li>Udarbejde beslutningsoplæg baseret på analyser og forretningsmål.</li>
            <li>Repræsentere kundens perspektiv i projekter og udvikling.</li>
            <li>Facilitere workshops og sikre fremdrift på tværs af teams.</li>
        </ul>

        <h2 className={'heading heading--montserrat heading--left heading--medium'}>
            Hvem er du?
        </h2>
        <p>
            Du har arbejdet med CX i en lignende virksomhed og trives med at tage ansvar og gøre ideer til virkelighed.
            Du tænker i løsninger, får folk med dig og bruger data aktivt i dit arbejde.
        </p>

        <h2 className={'heading heading--montserrat heading--left heading--medium'}>
            Du har:
        </h2>
        <ul className={'list list--bullet'}>
            <li>3-5 års erfaring med CX og digitale kunderejser, gerne fra tele- eller abonnementsverdenen.</li>
            <li>Et struktureret og handlekraftigt mindset og stærke skriftlige formidlingsevner.</li>
            <li>Hands-on erfaring med datadrevet arbejde.</li>
            <li>Arbejdet med UX og balancerer brugerens og forretningens behov.</li>
            <li>Styr på projektledelse og tværgående samarbejde.</li>
            <li>Måske har lidt HTML-erfaring.</li>
        </ul>

        <h2 className={'heading heading--montserrat heading--left heading--medium'}>
            Hvorfor Hiper?
        </h2>
        <p>
            I Hiper er vi kun gode til internet, men det er vi til gengæld virkelig gode til.
            Vores mission er at gøre det nemt at være kunde, nemt at bestille, nemt at sætte op og nemt at forstå.
        </p>
        <p>
            Vi har en flad struktur, højt tempo og kort vej fra idé til handling.
            Og selvom vi er en del af Nuuday-familien, har vi vores egen stil og måde at gøre tingene på.
        </p>
        <p>
            Hos os får du stor frihed og indflydelse på retningen &ndash; og kolleger, der brænder for at gøre tingene ordentligt og have det sjovt imens.
        </p>

        <h2 className={'heading heading--montserrat heading--left heading--medium'}>
            Ansøgning
        </h2>
        <p>
            Det er ikke nødvendigt at vedhæfte en motiveret ansøgning, men du bedes venligst inkludere en kort introduktion i dit CV om, hvorfor du søger denne stilling.
            For at sikre en fair og inkluderende rekrutteringsproces beder vi dig samtidig undlade at tilføje et foto til dit CV.
        </p>

        <div className={'cta-box'}>
            <p>
                <strong>Ansøgningsfrist:</strong> 4. juli 2025
            </p>
            <p>
                <strong>Kontaktperson:</strong> Nanna Lykke-Kjeldsen på <a href={'mailto:nlk@hiper.dk'}>nlk@hiper.dk</a>
            </p>
            <p>
                <strong>Arbejdssted:</strong> Teglholmsgade 1, 2450 København SV
            </p>

            <a
                href={'https://tdc.csod.com/ux/ats/careersite/17/home/requisition/9820?c=tdc&sq=req9820'}
                rel={'nofollow'}
                target={'_blank'}
                className={'button button--montserrat white-blue rounded with-icon'}
            >
                <span className={'text'}>Ansøg her</span>
                <Icon component={IconOpenInNew}/>
            </a>
        </div>

        <h2 className={'heading heading--montserrat heading--left heading--small'}>
            Nuuday &ndash; We make sense with technology
        </h2>
        <p>
            Hos Nudaay er vi 3.000 dedikerede medarbejdere, der på tværs af vores seks brands &ndash; YouSee, TDC Erhverv, Telmore, Hiper, eesy og Relatel &ndash; arbejder målrettet på at sætte retningen for Danmarks digitale fremtid.
            Vi befinder os midt i en spændende transformation, hvor vi ikke blot revolutionerer vores IT-systemer, men også skaber innovative digitale kundeoplevelser, der sætter nye standarder for, hvordan danskere, virksomheder og samfundet interagerer med teknologi i hverdagen.
            Hos Nuuday finder du en kultur præget af mangfoldighed, samarbejde og udvikling.
            Uanset hvor du arbejder, eller hvilket brand du er en del af, er én ting fælles for os alle: En passion for at skabe løsninger, der gør en forskel.
            Vi sætter en ære i at forstå vores kunder, og vi ser fremtiden som en mulighed for konstant at udvikle og forbedre os.
            Vi tror på, at et stærkt fællesskab lægger fundamentet for store resultater, og hos os er der altid plads til dem, der tør tænke nyt, tage ansvar og være med til at bane vejen.
            Vil du være med?
            Læs mere om, hvordan vi behandler dine personoplysninger her: <a href={'https://nuuday.dk/karriere'} rel={'nofollow'} target={'_blank'}>https://nuuday.dk/karriere</a>
        </p>
    </JobLayout>
}
